import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bulletin',
  templateUrl: './bulletin.component.html',
  styleUrls: ['./bulletin.component.scss'],
})
export class BulletinComponent implements OnInit{

    /**
     * Input data object from the backend. See eBulletinManagement.js for the spec.
     */
    @Input("bulletinObject") obj: {};

    /**
     * ngIf display flag.
     */
    display: boolean = false;

    /**
     * State variable. When true, applies the fade-out CSS animation class.
     */
    fade: boolean = false;

    /**
     * Is this a dismissible bulletin? Should it have the close button?
     */
    dismissible: boolean = false;

    /**
     * Name and type of this bulletin.
     */
    name: string;
    type: string;

    // For debugging.
    currentTime = 0;

    style: string = ''

    constructor(){}

    /**
     * Initialization angular lifecycle hook. Sets up lifecycle timers for the bulletin.
     */
    ngOnInit() {

        // Grab some properties we need.
        this.style = this.obj['alert']
        this.type = this.obj['type'];
        this.name = this.obj['name'];
        this.dismissible = this.obj['dismissible']=='true' || this.obj['dismissible'];

        // Initialize it as the correct type.
        switch ( this.type ) {
            case 'persistent': this.initAsPersistent(); break;
            case 'expiring':   this.initAsExpiring();   break;
            case 'timed':      this.initAsTimed();      break;
            case 'transient':  this.initAsTransient();  break;
        }

        // TODO: remove. For debugging purposes.
        setInterval(()=>{this.currentTime = Math.round(Date.now()*.001)},1000);


    }

    /**
     * Initialize this bulletin as a persistent one.
     */
    initAsPersistent() {

        // Get the current time. These are defined as seconds so we do some math.
        let now = Date.now() * .001;

        // Get the start time of the persistent banner.
        let start = this.obj['startTime'];

        this.display = false;

        // If it hasn't started yet, we do some scheduling.
        if ( now < start ) {
            let delay = (start-now) * 1000; // Back to millis.
            setTimeout(this.appear, delay)
        }
        else {
            this.appear();
        }

    }

    /**
     * Type specific initialization.
     */
    initAsTransient() {

        // Lets just let them exist for five seconds.
        let duration = 5000;

        // Start them off as visible.
        this.display = true;

        // Register a timeout so that after those five seconds we clear out.
        setTimeout( this.fadeOutAndHide, duration);
    }

    /**
     * Type specific initialization.
     */
    initAsExpiring() {

        // Grab the current time as always.
        let now = Date.now()*.001;

        this.display = false;

        // Grab the start time.
        let start = parseInt(this.obj['startTime']);

        // As this is an expiring bulletin, we need to grab the end time.
        let end = parseInt(this.obj['endTime']); // Also in seconds. Epoch seconds UTC, to be exact.

        // console.log("Init Expiring. Start:",start,"end:",end);

        // Schedule the start.
        if ( now < start ) {
            let delay = (start-now) * 1000;
            setTimeout( this.appear.bind(this), delay);
        }
        else if ( now < end ) {
            this.appear();
        }
        else {
            this.display = false;
            return; // If we're past the display window we don't need to do anything at all.
        }
        // Schedule the end.
        if ( now < end ) {
            let delay = (end-now) * 1000;
            setTimeout( this.fadeOutAndHide.bind(this), delay);
        }


    }

    /**
     * Type specific initialization.
     */
    initAsTimed() {
        // Timed ones are easier.
        let now = Date.now() * .001;
        let start = parseInt(this.obj['startTime']);
        let duration = parseInt(this.obj['duration']);
        let end = start+duration;

        // console.log("Init timed. Start:",start,"duration:",duration,"end:",end);

        // Schedule animations.
        if ( now < start ) {
            let startDelay = (start-now) * 1000;
            setTimeout( this.appear.bind(this), startDelay);
            let endDelay = (end-now) * 1000;
            setTimeout( this.fadeOutAndHide.bind(this), endDelay);
        }
        else if ( now > start && now < end ) {
            this.appear();
            let endDelay = (end-now) * 1000;
            setTimeout( this.fadeOutAndHide.bind(this), endDelay);
        }
        else { this.display = false; return; }
    }

    /**
     * Dismissal callback.
     */
    dismiss() {
        // Let's make this classy.
        this.fadeOutAndHide();
    }

    getBackgroundColor(): string {
        switch (this.style) {
            case 'high_alert':
                return '#FF0000';
            case 'low_alert':
                return '#ffc302';
            case 'no_alert':
                return '#fff';
            default:
                return '#FFFFFF';
        }
    }

    /**
     * Fade out and hide animation trigger.
     */
    fadeOutAndHide() {

        // Add the css class that handles the opacity animation.
        this.fade = true;
        // console.log(this.name,'going towards the light');

        // Hide the element after the fade.
        setTimeout( ()=>{this.display=false}, 500 );
    }

    /**
     * Show up and represent trigger.
     */
    appear() {
        this.fade = false; // Ensure that we aren't also fading out.
        // console.log(this.name,'appearing now');
        this.display = true;
    }
}